import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import StoreContext, { defaultStoreContext } from '../context/StoreContext'
import { GridThemeProvider, BaseCSS } from 'styled-bootstrap-grid2'
import Transition from '../components/transition'
import Footer from '../components/footer'
import Menu from '../components/header'
import CartMenu from '../components/cart_menu';
import GemPopup from '../components/gem_popup';
import Cookie from '../components/cookie_popup';

// fonts

import sigWoff from '../fonts/SignaturaMonolineScript-Regular.woff';
import sigWoff2 from '../fonts/SignaturaMonolineScript-Regular.woff2';

import { strictEqual } from 'assert';

import cursorpng from '../images/cursor.png';
import cursorpng2x from '../images/cursor2x.png';
import cursorsvg from '../images/cursor.svg';

const theme = {
  brown1: '#f8f7f6',
  brown2: '#ede9e2',
  brown3: '#d3cbc0',
  brown4: '#3c3c3b',
  grey: '#D8D8D8',
  headline_color: '#000000',
  text_color: '#3C3C3B',
  link_color: '#000000',
  menu: {
    fontsize: '11px',
    line_height: '18px',
  },
}

const GlobalStyle = createGlobalStyle`

  html {
    overflow-x: hidden;
    box-sizing: border-box;
    scroll-behavior: smooth;
  }

  body {
    cursor: url(${cursorpng}) 0 0, pointer; /* Legacy */
    cursor: url(${cursorsvg}) 0 0, pointer; /* FF */
    cursor: -webkit-image-set(url(${cursorpng}) 1x, url(${cursorpng2x}) 2x) 0 0, pointer; /* Webkit */
  }

  *, *:before, *:after {
    box-sizing: inherit;
    padding: 0;
    margin: 0;
  }

  button:focus {
    outline: 0;
  }

  body {
    background-color: #fff;
    font-family: 'minerva-modern', Garamond, Georgia, 'Times New Roman', Times, serif;
    font-size: 11px;
    margin: 0px;
    @media (max-width: 768px) {
        overflow-x: hidden;
        font-size: 13px;
        line-height: 18px;
    }
  }

  @font-face {
    font-family: 'Signatura Monoline Script';
    src: url(${sigWoff2}) format('woff2'),
        url(${sigWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  .sms {
    font-family: 'Signatura Monoline Script', Brush Script MT, Brush Script Std, cursive !important;
  }

  main {
    transition: all 0.25s ease-in-out;
    &.closed {
      @media (max-width: 768px) {
          transform: translateX(0px);
      }
    }
    &.open {
      @media (max-width: 768px) {
          transform: translateX(300px);
      }
    }
    @media (max-width: 768px) {
      padding-top: 100px;
    }
  }

  h3 {
    text-transform: uppercase;
    font-size: 13px;
    @media (max-width: 768px) {
      font-size: 15px;
    }
  }

  h4 {
    color: ${theme.text_color}
  }

  h5 {

  }

  i {
    font-family: 'minerva-modern', Garamond, Georgia, 'Times New Roman', Times, serif;
    font-style: italic;
  }

  p {
    color: ${theme.text_color};
    font-size: 12px;
    line-height: 20px;
    @media (max-width: 768px) {
      font-size: 15px;
      line-height: 21px;
    }
  }

  .slick-list,.slick-slider,.slick-track{position:relative;display:block}.slick-loading .slick-slide,.slick-loading .slick-track{visibility:hidden}.slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:0}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);-o-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.slick-track{top:0;left:0}.slick-track:after,.slick-track:before{display:table;content:''}.slick-track:after{clear:both}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}
  .slick-dots,.slick-next,.slick-prev{position:absolute;display:block;padding:0}.slick-dots li button:before,.slick-next:before,.slick-prev:before{font-family:slick;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-loading .slick-list{background:url(ajax-loader.gif) center center no-repeat #fff}@font-face{font-family:slick;font-weight:400;font-style:normal;src:url(fonts/slick.eot);src:url(fonts/slick.eot?#iefix) format('embedded-opentype'),url(fonts/slick.woff) format('woff'),url(fonts/slick.ttf) format('truetype'),url(fonts/slick.svg#slick) format('svg')}.slick-next,.slick-prev{font-size:0;line-height:0;top:50%;width:20px;height:20px;-webkit-transform:translate(0,-50%);-ms-transform:translate(0,-50%);transform:translate(0,-50%);cursor:pointer;color:transparent;border:none;outline:0;background:0 0}.slick-next:focus,.slick-next:hover,.slick-prev:focus,.slick-prev:hover{color:transparent;outline:0;background:0 0}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-size:20px;line-height:1;opacity:.75;color:#fff}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before{content:'â†'}.slick-next:before,[dir=rtl] .slick-prev:before{content:'â†’'}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}[dir=rtl] .slick-next:before{content:'â†'}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{bottom:-25px;width:100%;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;width:20px;height:20px;margin:0 5px;padding:0;cursor:pointer}.slick-dots li button{font-size:0;line-height:0;display:block;width:20px;height:20px;padding:5px;cursor:pointer;color:transparent;border:0;outline:0;background:0 0}.slick-dots li button:focus,.slick-dots li button:hover{outline:0}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:'â€¢';text-align:center;opacity:.25;color:#000}.slick-dots li.slick-active button:before{opacity:.75;color:#000}

  ::selection {
    background: #ede9e2;
  }
  ::-moz-selection {
    background: #ede9e2;
  }
`

const gridTheme = {
  breakpoints: { // defaults below
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 575,
  },
  row: {
    padding: 0,
  },
  col: {
    padding: 20,
  },
  container: {
    padding: 10,
    maxWidth: {
      xl: 1340,
      lg: 960,
      md: 720,
      sm: 540,
      xs: 540,
    },
  },
}

class Layout extends React.Component {

  constructor(props) {
    super(props)
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  state = {
    isOpen: false,
    store: {
      ...defaultStoreContext,
      toggleGem: (visible, name) => {
        let gemOpen;
        if(visible === false) {
          gemOpen = { visible: false, name: ''}
        } else {
          gemOpen = { visible: true, name: name}
        }

        this.setState(state => ({
          store: {
            ...state.store,
            gemOpen: {...gemOpen},
          },
        }))
      },

      toggleCare: (careVisible) => {
        this.setState(state => ({
          store: {
            ...state.store,
            careVisible: careVisible,
            shareVisible: false
          },
        }))
      },

      toggleShare: (shareVisible) => {
        this.setState(state => ({
          store: {
            ...state.store,
            shareVisible: shareVisible,
            careVisible: false
          },
        }))
      },

      togglePreorder: (preorderpopup) => {
        this.setState(state => ({
          store: {
            ...state.store,
            preorderpopup: preorderpopup
          },
        }))
      },

      selectLetter: (letter) => {
        this.setState(state => ({
          store: {
            ...state.store,
            letter: letter,
          },
        }))
      },

      setActiveSection: (section) => {
        this.setState(state => ({
          store: {
            ...state.store,
            activesection: section
          },
        }))
      },

      addVariantToCart: (variantId, quantity) => {
        if (variantId === '' || !quantity) {
          console.error('Both a size and quantity are required.')
          return
        }
        this.setState(state => ({
          store: {
            ...state.store,
            adding: true,
          },
        }))

        const { checkout, client } = this.state.store
        const checkoutId = checkout.id
        const lineItemsToUpdate = [
          { variantId, quantity: parseInt(quantity, 10) },
        ]

        return client.checkout
          .addLineItems(checkoutId, lineItemsToUpdate)
          .then(checkout => {
            this.setState(state => ({
              store: {
                ...state.store,
                checkout,
                adding: false,
              },
            }))
          })
      },
      removeLineItem: (client, checkoutID, lineItemID) => {
        return client.checkout
          .removeLineItems(checkoutID, [lineItemID])
          .then(res => {
            this.setState(state => ({
              store: {
                ...state.store,
                checkout: res,
              },
            }))
          })
      },
      updateLineItem: (client, checkoutID, lineItemID, quantity) => {
        const lineItemsToUpdate = [
          { id: lineItemID, quantity: parseInt(quantity, 10) },
        ]

        return client.checkout
          .updateLineItems(checkoutID, lineItemsToUpdate)
          .then(res => {
            this.setState(state => ({
              store: {
                ...state.store,
                checkout: res,
              },
            }))
          })
      },
    },
  }

  async initializeCheckout() {
    // Check for an existing cart.
    const isBrowser = typeof window !== 'undefined'
    const existingCheckoutID = isBrowser
      ? localStorage.getItem('shopify_checkout_id')
      : null

    const setCheckoutInState = checkout => {
      if (isBrowser) {
        localStorage.setItem('shopify_checkout_id', checkout.id)
      }

      this.setState(state => ({
        store: {
          ...state.store,
          checkout,
        },
      }))
    }

    const createNewCheckout = () => this.state.store.client.checkout.create()
    const fetchCheckout = id => this.state.store.client.checkout.fetch(id)

    if (existingCheckoutID) {
      try {
        const checkout = await fetchCheckout(existingCheckoutID)

        // Make sure this cart hasn’t already been purchased.
        if (!checkout.completedAt) {
          setCheckoutInState(checkout)
          return
        }
      } catch (e) {
        localStorage.setItem('shopify_checkout_id', null)
      }
    }

    const newCheckout = await createNewCheckout()
    setCheckoutInState(newCheckout)
  }

  componentDidMount() {
    this.initializeCheckout()
  }

  toggleMenu() {
    this.setState({isOpen:!this.state.isOpen});
  }

  render() {

    const { children, location } = this.props
    return (
      <StoreContext.Provider value={this.state.store}>
        <GlobalStyle/>
        <StaticQuery
          query={graphql`
            query SiteTitleQuery {
              site {
                siteMetadata {
                  title
                }
              }
            }
          `}
          render={data => (
            <>
              <BaseCSS />
              <GlobalStyle />
              <GemPopup gemOpen={this.state.store.gemOpen} />
              <ThemeProvider theme={theme}>
                <GridThemeProvider gridTheme={gridTheme}>
                  <div>
                    <CartMenu />
                    <Menu toggleMenu={this.toggleMenu} isOpen={this.state.isOpen} location={location} />
                    <main className={this.state.isOpen ? 'open' : 'closed'}>
                      <Transition location={location}>
                        {children}
                      </Transition>
                    </main>
                    <Footer location={location} />
                    <Cookie />
                  </div>
                </GridThemeProvider>
              </ThemeProvider>
            </>
          )}
        />
      </StoreContext.Provider>
    )
  }
}


Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
